<template>
  <div class="form-group">
    <label :for="name">
      {{ label }}<span
        v-if="required"
        class="required-indicator"
        aria-hidden="true"
      > *</span>
    </label>

    <VeeField
      :id="name"
      v-model="localValue"
      :name="name"
      :label="label"
      :as="type === 'select' ? 'select' : 'input'"
      :type="type !== 'select' ? type : undefined"
      :aria-required="required ? 'true' : undefined"
      class="form-input"
      v-bind="$attrs"
    >
      <template v-if="type === 'select'">
        <option
          value=""
          disabled
        >
          Select {{ label }}
        </option>
        <option
          v-for="opt in options"
          :key="opt.value"
          :value="opt.value"
        >
          {{ opt.label }}
        </option>
      </template>
    </VeeField>

    <VeeErrorMessage
      :name="name"
      class="form-error"
    />
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    name: { type: String, required: true },
    label: { type: String, default: '' },
    modelValue: { type: [String, Number], default: '' },
    type: { type: String, default: 'text' },
    required: { type: Boolean, default: false },
    options: { type: Array, default: () => [] }
  },
  emits: ['update:modelValue'],
  computed: {
    localValue: {
      get () {
        return this.modelValue
      },
      set (val) {
        this.$emit('update:modelValue', val)
      }
    }
  }
}
</script>
<style scoped>
.required-indicator {
  color: #dc2626;
}
</style>
